/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FcbAdjointGridDto
 */
export interface FcbAdjointGridDto {
    /**
     * 
     * @type {string}
     * @memberof FcbAdjointGridDto
     */
    titre?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FcbAdjointGridDto
     */
    nom?: string | null;
}

/**
 * Check if a given object implements the FcbAdjointGridDto interface.
 */
export function instanceOfFcbAdjointGridDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbAdjointGridDtoFromJSON(json: any): FcbAdjointGridDto {
    return FcbAdjointGridDtoFromJSONTyped(json, false);
}

export function FcbAdjointGridDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbAdjointGridDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'titre': !exists(json, 'titre') ? undefined : json['titre'],
        'nom': !exists(json, 'nom') ? undefined : json['nom'],
    };
}

export function FcbAdjointGridDtoToJSON(value?: FcbAdjointGridDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'titre': value.titre,
        'nom': value.nom,
    };
}

